module.exports = __webpack_public_path__ + "static/media/icon_join.acbc47f5.png";